import { useCallback, useEffect, useState } from "react";
import api from "./api";
import { canSee, visibleNav } from "./nav";

/**
 * Mobilní navigace (plátno 16A): dolní lišta, menu modulů přes celou obrazovku
 * a upozornění. Vše se skládá z NAV v lib/nav.js, takže role platí stejně jako
 * v levém panelu na počítači.
 */

// Stránky, které patří pod položku, i když nejsou přímo v NAV (detail technologie je obchod).
const PATRI_POD = { obchod: ["/technologie"], polozky: ["/cenik"] };

const sedi = (pathname, path) =>
  path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`);

/** Je položka (i skupina) aktivní pro tuto adresu? */
export function jeAktivni(polozka, pathname) {
  const cesty = [
    ...(polozka.children ? polozka.children.map((c) => c.path) : [polozka.path]),
    ...(PATRI_POD[polozka.key] || []),
  ].filter(Boolean);
  return cesty.some((p) => sedi(pathname, p));
}

/** Dolní lišta: prvních 5 hlavních položek; skupina vede na svůj první modul. */
export function polozkyListy(user) {
  return visibleNav(user, canSee).slice(0, 5).map((i) => ({
    ...i,
    cil: i.children ? i.children[0].path : i.path,
  }));
}

/** Menu modulů po sekcích: samostatné položky nahoře, skupiny, zbytek pod „Firma". */
export function sekceMenu(user) {
  const nav = visibleNav(user, canSee);
  const prvniSkupina = nav.findIndex((i) => i.children);
  const nahore = prvniSkupina < 0 ? nav : nav.slice(0, prvniSkupina);
  const skupiny = nav.filter((i) => i.children);
  const zbytek = prvniSkupina < 0 ? [] : nav.slice(prvniSkupina).filter((i) => !i.children);
  return [
    { klic: "hlavni", titul: null, polozky: nahore },
    ...skupiny.map((g) => ({ klic: g.key, titul: g.label, polozky: g.children })),
    { klic: "firma", titul: "Firma", polozky: [...zbytek, { key: "nastaveni", label: "Nastavení", path: "/nastaveni", icon: "Settings" }] },
  ].filter((s) => s.polozky.length);
}

/**
 * Čísla do menu a upozornění: počty z přehledu + odznak servisu.
 * Načte se při startu a znovu, když si uživatel otevře menu nebo zvonek.
 */
export function useOdznaky() {
  const [souhrn, setSouhrn] = useState({});
  const [servis, setServis] = useState({});
  const obnovit = useCallback(() => {
    api.get("/api/dashboard/summary").then(({ data }) => setSouhrn(data || {})).catch(() => {});
    api.get("/api/servis/badge").then(({ data }) => setServis(data || {})).catch(() => {});
  }, []);
  useEffect(() => { obnovit(); }, [obnovit]);
  const doklady = souhrn.pocet_dokladu_po_splatnosti || 0;
  return {
    souhrn, servis, obnovit,
    // Červené odznaky = něco propadlo; šedé číslo = jen počet.
    odznak: (key) => (key === "servis" ? servis.count || 0 : key === "doklady" ? doklady : 0),
  };
}
